<template>
    <div class="form-group">
        <label v-if="label" :class="{ 'form-label-icon': !!icon }" :for="labelFor || undefined">
            <i v-if="icon" :class="icon" aria-hidden="true"></i>
            <span v-if="icon">{{ label }}</span>
            <template v-else>{{ label }}</template>
        </label>
        <slot></slot>
        <div v-if="error" class="form-error">{{ error }}</div>
    </div>
</template>

<script setup lang="ts">
defineOptions({ name: "UiFormGroup" });

const {
    label = "",
    icon = "",
    error = "",
    labelFor = "",
} = defineProps<{
    label?: string;
    icon?: string;
    error?: string;
    labelFor?: string;
}>();
</script>
